import { searchResults } from '../stores.js'
import { core_site } from './mysite.js';

const cache = {};

export const searchOptions = {
	search: '',
	searchType: 'items',
	maxEntries: 50,
	floatyBoxes: false,
	mediawikiSearch: true,
	disableRequire: false,
	disableSet: false,
	customSet: '',
	customRequire: '',
	customSalvage: '',
};

export async function buildCache() {
	
	const queries = ['items', 'achievements', 'homestead'];

	for (let query of queries) {
		const res = await fetch(`${core_site}/gw2w/list/${query}`);
		if (res.status !== 200) console.error(`Cache lookup returned ${res.status}`);
		
		const data = await res.json();
		if (!data) {
			console.error('Error fetching cache.');
			return;
		}
		console.log(`Added ${query} to cache.`);
		cache[query] = data.foo;
	}		
}
// buildCache();

export async function partialSearch(searchOptions) {
	const res = await fetch(`${core_site}/gw2w/list/${searchOptions.searchType}?search=${searchOptions.search}`);
	if (res.status !== 200) console.error(`Search lookup returned ${res.status}`);
		
	const data = await res.json();
	if (!data) {
		console.error('Error fetching search.');
		return;
	}
	return data;
}

export async function searchCache(searchOptions) {
	if (!searchOptions.search) return;

	let searchRes;
	if (!cache[searchOptions.searchType]) {
		console.log(`No cache for ${searchOptions.searchType}, fetching`);
		//const fetched = await partialSearch(searchOptions);
		//searchRes = fetched.foo;
	} else {
		searchRes = cache[searchOptions.searchType];
	}

	if (!searchRes) return;
	
	let filtered = searchRes.filter( entry => {
		if (!entry.name) return false;
		return entry.name.toLowerCase().includes(searchOptions.search.toLowerCase())
	});

	if (filtered.length >= searchOptions.maxEntries) {
		filtered = filtered.slice(0, searchOptions.maxEntries);
	}
	searchResults.set(filtered);
	return
}